module.exports = __webpack_public_path__ + "static/img/4-2.1b359126.png";